import { render, staticRenderFns } from "./specifications.form.vue?vue&type=template&id=82582760&"
import script from "./specifications.form.vue?vue&type=script&lang=js&"
export * from "./specifications.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports